export class PopupBlockedError extends Error {
  constructor() {
    super('OAuth popup was blocked by the browser');
    this.name = 'PopupBlockedError';
  }
}

export type PopupWindow = {
  navigate: (url: string) => void;
  close: () => void;
  isSource: (source: MessageEventSource | null) => boolean;
  readonly closed: boolean;
};

export type PopupSize = {
  width: number;
  height: number;
};

type PopupPosition = {
  left: number;
  top: number;
};

const DEFAULT_SIZE: PopupSize = { width: 500, height: 500 };

function centered({ width, height }: PopupSize): PopupPosition {
  const currentLeft = window.screenLeft ?? window.screenX;
  const currentTop = window.screenTop ?? window.screenY;
  const viewportWidth = window.innerWidth || screen.width;
  const viewportHeight = window.innerHeight || screen.height;

  return {
    left: currentLeft + (viewportWidth - width) / 2,
    top: currentTop + (viewportHeight - height) / 2,
  };
}

function features(size: PopupSize, { left, top }: PopupPosition): string {
  return `popup,width=${size.width},height=${size.height},left=${left},top=${top}`;
}

export function openBlankPopup(size: PopupSize = DEFAULT_SIZE): PopupWindow {
  const nativeWindow = window.open(
    'about:blank',
    '_blank',
    features(size, centered(size))
  );

  if (!nativeWindow) {
    throw new PopupBlockedError();
  }

  return {
    navigate: (url) => {
      nativeWindow.location.href = url;
    },
    close: () => nativeWindow.close(),
    isSource: (source) => source === nativeWindow,
    get closed() {
      return nativeWindow.closed;
    },
  };
}
